import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CompressedGas } from '../model/compressedGasesAir';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class CompressedGasService {

    constructor(private http: HttpClient) {
    }

    save(gas: CompressedGas, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/compressedGas/create/${executionId}`;
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.post(url, gas, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    update(gas: CompressedGas, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/compressedGas/${gas.id}/${executionId}`;
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.put(url, gas, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    delete(gas: CompressedGas, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/compressedGas/${gas.id}/${executionId}`;
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.delete(url, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

}
